import React, { Component } from 'react';
import * as Gserv from '../services/GatewayService';
import { TimelineTwoTone, UndoTwoTone, PrintTwoTone, Settings} from '@material-ui/icons';
import {Paper, Grid, Typography, IconButton, Button, Tooltip} from '@material-ui/core';
import DatasheetView from './DatasheetView';
import ReactToPrint from 'react-to-print';
import TMBlock from './TMBlock';
import XLSX from 'xlsx';
import ExcelLogo from '../assets/icons8-export-excel-24.png';
import moment from 'moment';
import Toggle from './Toggle';


export default class TalentMatrixReportByROM extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            tm_avail: [],
            tm_categories: [],
            current_filter: {},
            tm_display_array: [],
            error: false,
            error_message: '',
            querying: true,
            show_report: false,
            show_all: false,
            block : 'C3'
        };
        this.datasheetFieldSpecs = [
            // { field: 'id', headerName: 'Empl. #', width: 90, sortable:false},
            { field: 'report', headerName: 'Report', width: 80, headerAlign: 'center',
            sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.showReport(parms)} 
                    color='primary'
                >
                    <TimelineTwoTone/>
                </IconButton>
            )},
            // { field: 'name', headerName: 'Assessee', width: 130},
            // { field: 'assessee_id', headerName: 'Employee#', width: 130},
            { field: 'cycle_code', headerName: 'Cycle Code', width: 130},
            { field: 'cycle_name', headerName: 'Cycle', width: 350},
            { field: 'reports_to_rom', headerName: 'Manager Code', width: 130},
        ]
    }

    componentDidMount = (show_all = false) => {
        //async request list of Talent Matrix reports available...
        if (this.state.tm_avail.length===0 || this.state.show_all!==show_all){  
            this.setState({querying:true, tm_avail:[], tm_categories:[]}); 
            Gserv.sendCommand('query_tm_avail',this.props.gwt,{
               filter : "by_rom",  //Do we need this?
               show_all : show_all
            })
            .then(tm_avail => {
                // console.log('tm_avail :>> ', tm_avail);
                if (tm_avail.error){
                    console.log('error on return from Gserv (query_tm_avail) :>> ', tm_avail);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (tm_avail.Result!=="Success"&&tm_avail.statusCode!==204){
                    console.log('error on return from Gserv (query_tm_avail) :>> ', tm_avail);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (tm_avail.statusCode===204){
                //     this.setState({error:true,error_message:"There are no Talent Matrix reports available yet.",querying:false});
                    this.setState({querying: false});
                } else if (tm_avail.Records.length>0) {
                    let tmSet = new Set();
                    for (const tm_record of tm_avail.Records){
                        tmSet.add(JSON.stringify({id : tm_record.cycle_id + "|" + tm_record.reports_to_rom,reports_to_rom : tm_record.reports_to_rom, cycle_id : tm_record.cycle_id, cycle_code : tm_record.cycle_code, cycle_name : tm_record.cycle_name }));
                    }
                    let cat_array = [];
                    for (const tm_record of tmSet){
                        cat_array.push(JSON.parse(tm_record));
                    }
                    // console.log('tmSet :>> ', tmSet);
                    this.setState({tm_avail: tm_avail.Records, tm_categories: cat_array,querying:false});
                }
            }); 
        }
    };

    resetMe = () => {
        this.setState({error: false,error_message:'',show_report:false});
    }    

    showReport = (record) => {
        // console.log('record :>> ', record);
        const cycle_filter = record.row.cycle_id;
        const rom_filter = record.row.reports_to_rom;
        var filtered_array = [];
        for (const tm_rec of this.state.tm_avail){
            if (tm_rec.cycle_id === cycle_filter && tm_rec.reports_to_rom === rom_filter){
                filtered_array.push(tm_rec);
            }
        }

        // console.log('filtered_array :>> ', filtered_array);
        this.setState({
            tm_display_array:filtered_array,
            show_report:true,
            current_filter: record.row
        });

    }

    exportMe = () => {
        // console.log('called exportMe...');
        if (this.state.tm_display_array.length>0){
            const dateStr = new moment().format("YYYY-MM-DD");
            var ws = XLSX.utils.json_to_sheet(this.state.tm_display_array);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'TM Data ' + dateStr);
            //Write to browser
            XLSX.writeFile(wb,'TMS Export - TM Data for ' + this.state.current_filter.cycle_code + ' for ' + this.state.current_filter.reports_to_rom + ' as at ' + dateStr + '.xlsx');
        }
    }

    handleToggleChange = (e) => {
        // console.log('e :>> ', e);
        // console.log("State show_all: ", this.state.show_all,' e.value: ',e.value);
        switch (e.field) {
            case 'show_all':
                if (e.value !== this.state.show_all){
                    this.setState({show_all:e.value});
                    this.componentDidMount(e.value);
                }
                break;

            default:
                break;
        }
    }

    render() {return(
        <Grid
            container
            direction='column'
            justifyContent='flex-start'
            alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >

            {!this.state.show_report&&
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:1000
                }}
            >
                <Grid container>
                <Grid item xs={4}></Grid>
                <Grid item xs ={4}>
                    <Typography
                        color='primary'
                        style={{padding:15}}
                        
                    >
                        Available Talent Matrix Reports<br/>by Manager
                    </Typography>
                </Grid>

                <Grid item xs={4}>
                    <div style={{paddingLeft:'40px', paddingTop:15}}>
                        <Toggle
                            fieldMap={{field: "show_all", headerName: "Include Closed Cycles?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true}} 
                            editRecord={{show_all: this.state.show_all}}
                            setField={this.handleToggleChange}
                        />
                    </div>
                </Grid>
                </Grid>
            
                {/* Datagrid goes here */}
                <DatasheetView 
                    dataset={this.state.tm_categories}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={false}
                    edit={false}
                    handleDelete={null}
                    handleEdit={null}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={15}
                    height={600}
                />
            </Paper>
            </Grid>}

            {this.state.show_report&&
            <Grid item>
            
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1000,
                        padding:15,
                    }}
                >
                    <Tooltip title="Back"><IconButton aria-label='Back' onClick={()=>this.setState({show_report:false, current_record:{}})}><UndoTwoTone /></IconButton></Tooltip>

                    <Tooltip title="Print or save as .pdf">
                        <span>
                        <ReactToPrint
                            content={() => this.componentRef}
                            bodyClass={'printSpecs'}
                            pageStyle={''}
                            trigger={() => <IconButton aria-label='Print or save as .pdf'><PrintTwoTone /></IconButton>}
                        />
                        </span>
                    </Tooltip>

                    <IconButton 
                        aria-label='Export to Excel'
                        onClick={this.exportMe}
                        disabled={this.state.tm_display_array.length===0}
                    >
                        <Tooltip title="Export to Excel">
                            <img
                                src={ExcelLogo}
                                alt={'MS Excel'}
                                // height={78}
                                // width={161}
                            />
                        </Tooltip>
                    </IconButton>


                </Paper>

                <div id='Print Delimiter' 
                    ref={(response) => (this.componentRef = response)}
                >        

                <div
                    style={{borderWidth:'1px',borderStyle:'solid',padding:'10px'}}
                    
                >
                    <Typography color='primary' variant='h6'>Talent Matrix Report by Manager</Typography>
                    <Typography>For Manager Code: <b>{this.state.current_filter.reports_to_rom}</b> for cycle <b>{this.state.current_filter.cycle_code}</b> : {this.state.current_filter.cycle_name}</Typography>
                    <Typography>Generated : {new Date().toDateString()}</Typography>
                </div>

                {this.state.querying&&
                <Typography
                    style={{marginTop:25}}
                >
                    <Settings className='icn-spinner' /><br/>
                    Extracting report data...
                </Typography>}

                {!this.state.querying&&
                <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'blue',
                        width:1000,
                        padding:15
                    }}
                >
                <table>
                <tbody>
                    <tr>
                        <td colSpan={2} rowSpan={2}>
                            <Grid container direction='column' alignItems='center'>
                            <Grid 
                                container
                                direction='row'
                                justifyContent='center'
                                alignItems='center'
                                style={{
                                    borderWidth:1,
                                    borderStyle:'dashed',
                                    borderColor:'#bcbec0',
                                    width:'90%'
                                }}
                            >
                                <Typography>
                                    Assessees this Cycle:
                                </Typography>
                                &nbsp;
                                <Typography
                                    color="primary"
                                >
                                    {this.state.tm_display_array.length}
                                </Typography>
                               
                            </Grid>
                            </Grid>
                        </td>
                        {/* <td></td> */}
                        <td colSpan={3}>
                            <Typography>&gt;&gt;&nbsp;&nbsp;POTENTIAL&nbsp;&nbsp;&gt;&gt;</Typography>
                            <hr/>
                        </td>
                    </tr>
                    <tr>
                        {/* <td>hello</td> */}
                        {/* <td>world</td> */}
                        <td>
                            <Typography style={{textAlign: 'center'}}>LOW POTENTIAL</Typography>
                        </td>
                        <td>
                            <Typography style={{textAlign: 'center'}}>STRONG</Typography>
                        </td>
                        <td>
                            <Typography style={{textAlign: 'center'}}>HIGH POTENTIAL</Typography>
                        </td>
                    </tr>
                    <tr>
                        <td rowSpan={3}
                            style={{
                                borderRight: '2px #bcbec0',
                                borderRightStyle:'inset',
                                maxWidth:'80px',
                            }}
                        >
                            <Typography
                                className='verticalText'
                            >
                                &gt;&gt;&nbsp;&nbsp;PERFORMANCE&nbsp;&nbsp;&gt;&gt;
                            </Typography>
                        </td>
                        <td style={{paddingLeft:10, paddingRight:10, maxWidth:150}}>
                            <Typography
                                // className='verticalText'                            
                            >
                                EXCEPTIONAL / ABOVE TARGET / ROLE MODEL
                            </Typography>
                        </td>

                        <TMBlock
                            designation={'C1'}
                            array={this.state.tm_display_array}
                        />
                        <TMBlock
                            designation={'B1'}
                            array={this.state.tm_display_array}
                        />
                        <TMBlock
                            designation={'A1'}
                            array={this.state.tm_display_array}
                        />

                    </tr>
                    <tr>
                        <td style={{paddingLeft:10, paddingRight:10, maxWidth:150}}>
                            <Typography
                                // className='verticalText'                            
                            >
                                SOLID / ON TARGET
                            </Typography>        
                        </td>

                        <TMBlock
                            designation={'C2'}
                            array={this.state.tm_display_array}
                        />
                        <TMBlock
                            designation={'B2'}
                            array={this.state.tm_display_array}
                        />
                        <TMBlock
                            designation={'A2'}
                            array={this.state.tm_display_array}
                        />

                    </tr>
                    <tr>
                        <td style={{paddingLeft:10, paddingRight:10, maxWidth:150}}>
                            <Typography
                                // className='verticalText'                            
                            >
                                DEVELOPMENT NEEDED / BELOW TARGET / BELOW EXPECTATIONS
                            </Typography>
                        </td>

                        <TMBlock
                            designation={'C3'}
                            array={this.state.tm_display_array}
                        />
                        <TMBlock
                            designation={'B3'}
                            array={this.state.tm_display_array}
                        />
                        <TMBlock
                            designation={'A3'}
                            array={this.state.tm_display_array}
                        />
 
                    </tr>
                </tbody>
            </table>
            </Paper>
            </Grid>}

            </div> 

            </Grid>}

            <Grid item>
                <Typography color='secondary' style={{Width:1000,maxWidth:1000, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>
            <br/>

        </Grid>
    )}
}